import React from 'react';
import { Icon } from '@iconify/react';
import {
    CategoryIconSet,
    getHotelCategoryIcons,
    HOTEL_CATEGORY_ICONS,
} from '../../../utils/HotelCategoryIconUtils';
import '../../../stylesheets/hotel-category.scss';

import Tooltip from '../../../../../muiComponents/Tooltip';

interface HotelCategoryProps {
    categoryKey: string;
    category?: string;
    size?: number;
}

const HotelCategory = ({
    categoryKey,
    category,
    size = 16,
}: HotelCategoryProps) => {
    const iconSet: CategoryIconSet = getHotelCategoryIcons(categoryKey);

    if (!iconSet) {
        return (
            <Tooltip titleText={category} placement='top'>
                <span className='hotel-category__icons'>
                    <Icon
                        icon={HOTEL_CATEGORY_ICONS.HOTEL}
                        width={size}
                        height={size}
                    />
                </span>
            </Tooltip>
        );
    }

    return (
        <Tooltip titleText={category} placement='top'>
            <span className='hotel-category__icons'>
                {iconSet.type === 'apartment' && (
                    <Icon
                        icon={HOTEL_CATEGORY_ICONS.APARTMENT}
                        width={size}
                        height={size}
                    />
                )}
                {iconSet.type === 'stars' && (
                    <>
                        {Array.from({ length: iconSet.full }).map((_, i) => (
                            <Icon
                                key={`full-${i}`}
                                icon={HOTEL_CATEGORY_ICONS.STAR_FULL}
                                width={size}
                                height={size}
                            />
                        ))}
                        {iconSet.half && (
                            <Icon
                                icon={HOTEL_CATEGORY_ICONS.STAR_HALF}
                                width={size}
                                height={size}
                            />
                        )}
                        <span className='hotel-category__icons--empty'>
                            {Array.from({ length: iconSet.empty }).map(
                                (_, i) => (
                                    <Icon
                                        key={`empty-${i}`}
                                        icon={HOTEL_CATEGORY_ICONS.STAR_EMPTY}
                                        width={size}
                                        height={size}
                                    />
                                )
                            )}
                        </span>
                    </>
                )}
                {iconSet.type === 'keys' && (
                    <>
                        {Array.from({ length: iconSet.full }).map((_, i) => (
                            <Icon
                                key={`full-${i}`}
                                icon={HOTEL_CATEGORY_ICONS.KEY_FULL}
                                width={size}
                                height={size}
                                style={{ transform: 'rotate(45deg)' }}
                            />
                        ))}
                        <span className='hotel-category__icons--empty'>
                            {Array.from({ length: iconSet.empty }).map(
                                (_, i) => (
                                    <Icon
                                        key={`empty-${i}`}
                                        icon={HOTEL_CATEGORY_ICONS.KEY_EMPTY}
                                        width={size}
                                        height={size}
                                        style={{ transform: 'rotate(45deg)' }}
                                    />
                                )
                            )}
                        </span>
                    </>
                )}
            </span>
        </Tooltip>
    );
};

export default HotelCategory;
